export default __webpack_public_path__ + "static/media/sacetbarquette.84e7bfb7.svg";